export default __webpack_public_path__ + "f4ab3ba4ac87c32df4595799082e3a0d.png";